export const markerLayout = () => {
	const layout = ymaps.templateLayoutFactory.createClass(
		`<div class="placemark" data-id="$[id]"><img src="$[properties.hrefImage]"></div>`,
		{
			build: function () {
				layout.superclass.build.call(this);
				const map = this.getParentElement().closest(`div.map`);
				const element = this.getParentElement().getElementsByClassName(`placemark`)[0];
				const section = element.closest(`section`);
				const current = section.querySelector(`ul li.tns-slide-active`).getAttribute(`data-id`);

				// map.querySelector(`div.placemark.current`) ? map.querySelector(`div.placemark.current`).classList.remove(`current`) : false;
				element.getAttribute(`data-id`) === current ? element.classList.add(`current`) : false;

				const shape = {type: `Circle`, coordinates: [0, 0], radius: element.offsetWidth / 2};
				const shapeCurrent = {type: `Circle`, coordinates: [0, 0], radius: 20 * element.offsetWidth / 100 + element.offsetWidth / 2};

				this.getData().options.set(`shape`, element.classList.contains(`current`) ? shapeCurrent : shape);

				element.querySelector(`img`).addEventListener(`load`, () => {
					element.classList.add(`loaded`);
				});
			}
		}
	);

	return layout;
};
